import { render, staticRenderFns } from "./AutoRegister.vue?vue&type=template&id=b9475ea8&scoped=true"
import script from "./AutoRegister.vue?vue&type=script&lang=js"
export * from "./AutoRegister.vue?vue&type=script&lang=js"
import style0 from "./AutoRegister.vue?vue&type=style&index=0&id=b9475ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9475ea8",
  null
  
)

export default component.exports